export default {
  methods: {
    checkNumberOnly(e, isNumberZero = false) {
      if(!isNumberZero && ['0'].includes(e.key) && e.target.value === '') {
        e.preventDefault();
      }
      if(['+','-','e','.',','].includes(e.key)) {
        e.preventDefault();
      }
      if([13, 37, 39].includes(e.keyCode)) {
        return;
      }
      if (e.keyCode && ((e.keyCode < 8 || e.keyCode > 9) && e.keyCode < 46 || (e.keyCode > 57 && (e.keyCode < 96 || e.keyCode > 105)))) {
        e.preventDefault();
      }
    },

    checkNumberAndZero(e) {
      if(["0"].includes(e.key) && e.target.value === "0") {
        e.preventDefault();
      }

      if(['+','-','e','.',','].includes(e.key)) {
        e.preventDefault();
      }

      if([13, 37, 39].includes(e.keyCode)) {
        return;
      }

      if (e.keyCode && ((e.keyCode < 8 || e.keyCode > 9) && e.keyCode < 46 || (e.keyCode > 57 && (e.keyCode < 96 || e.keyCode > 105)))) {
        e.preventDefault();
      }
    },

    mixinCheckMailMultiplay(val) {
      //eslint-disable-next-line
      const reg = /^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,4},*[\W]*)+$/;
      return reg.test(val);
    },

    checkNumberNegativeOnly(e) {
      if(['+','e','.',','].includes(e.key)) {
        e.preventDefault();
      }
      if (document.getSelection().toString() !== '') {
        return;
      }
      let val = e.target.value.replace(/[0-9]/g, '');
      if(e.key === '-' && val !== '-') {
        return;
      }
      if([13, 37, 39].includes(e.keyCode)) {
        return;
      }
      if (e.keyCode && ((e.keyCode < 8 || e.keyCode > 9) && e.keyCode < 46 || (e.keyCode > 57 && (e.keyCode < 96 || e.keyCode > 105)))) {
        e.preventDefault();
      }
    },

    checkLengthInput(e, maxLength) {
      if (document.getSelection().toString() !== '' || e.key === '-') {
        return;
      }
      let val = e.target.value.replace(/[.,-]/g, '');
      if (val.length >= maxLength && e.keyCode && e.keyCod !==46 && e.keyCode !== 8 && e.keyCode !== 9 && e.keyCode !== 13 && e.keyCode !== 37 && e.keyCode !== 39 && e.keyCode !== 100 && e.keyCode !== 102) {
        e.preventDefault();
      }
    },

    /*checkInputAccount(e) {
      let str = e.target.value
      let dotAfter = str.split('[.\\,/]')[1];
      let dotBefore = str.split('[.\\,/]')[0];
      console.log(dotAfter, 'after');
      console.log(dotBefore, 'before')
      if (dotBefore.length >= 2 && e.keyCode && e.keyCod !==46 && e.keyCode !== 8 && e.keyCode !== 9 && e.keyCode !== 13 && e.keyCode !== 37 && e.keyCode !== 39 && e.keyCode !== 100 && e.keyCode !== 102) {
        e.preventDefault();
      }
      if (dotAfter && dotAfter.length >= 2 && e.keyCode && e.keyCod !==46 && e.keyCode !== 8 && e.keyCode !== 9 && e.keyCode !== 13 && e.keyCode !== 37 && e.keyCode !== 39 && e.keyCode !== 100 && e.keyCode !== 102) {
        e.preventDefault();
      }
    },*/

    mixincheckNumberWithoutZero(e) {
      if(['+','-','e','.',','].includes(e.key)) {
        e.preventDefault();
      }
      if (document.getSelection().toString() !== '') {
        return;
      }
      if([13, 37, 39].includes(e.keyCode)) {
        return;
      }
      if (e.keyCode && ((e.keyCode < 8 || e.keyCode > 9) && e.keyCode < 46 || (e.keyCode > 57 && (e.keyCode < 96 || e.keyCode > 105)))) {
        e.preventDefault();
      }
    },

    mixinCheckNumberWithDot(e) {
      if(['+','-','e'].includes(e.key)) {
        e.preventDefault();
      }
      if(['.',','].includes(e.key)) {
        return;
      }
      if([13, 37, 39, 110].includes(e.keyCode)) {
        return;
      }
      if (e.keyCode && ((e.keyCode < 8 || e.keyCode > 9) && e.keyCode < 46 || (e.keyCode > 57 && (e.keyCode < 96 || e.keyCode > 105)))) {
        e.preventDefault();
      }
    },
  }
}